/*
 * Module for the Vendor Home User Flags menu
*/

rs.module("vendor/home/userflagsmenu",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _userFlags;

        function initialize(jsSelectors, cssClasses, backendUrl) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _userFlags = $.js(_jsSelectors.userFlags);

            // show/hide user flags menu when toggle button is clicked
            _userFlags.js(_jsSelectors.toggle).click(function () {
                _userFlags.js(_jsSelectors.menu).toggle();
            });

            // hide user flags menu if user clicks anywhere outside of it
            $("body").click(function (event) {
                if ($(event.target).closest(`[data-js~=${_jsSelectors.userFlags}`).length == 0) {
                    _userFlags.js(_jsSelectors.menu).hide();
                }
            });

            // subscribe/unsubscribe to user flag
            _userFlags.js(_jsSelectors.flagCheckbox, { multiple: true, required: false }).change(function () {

                $.post(backendUrl, {
                    "userflagkey": $(this).data("userflagkey"),
                    "flagvalue": $(this).is(":checked"),
                    "ownerkey": $(this).data("ownerkey"),
                    "grouptype": $(this).data("grouptype"),
                    "orgreferencenumber": $(this).data("orgreferencenumber")
                });

                _toggleUserFlagsIcon();
            });
        }

        //
        // Toggle user flag icon based on whether any flags are selected
        //
        function _toggleUserFlagsIcon() {

            var flagSelected = _userFlags.js(_jsSelectors.flagCheckbox, { multiple: true, required: false }).filter(":checked").length > 0;

            _userFlags.js(_jsSelectors.flagIcon).toggleClass(_cssClasses.solid, flagSelected);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);